var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3441 7.40144C14.3441 6.91002 14.3 6.4375 14.2181 5.98389H7.69104V8.66464H11.4208C11.2601 9.53093 10.7719 10.2649 10.0379 10.7563V12.4952H12.2776C13.5881 11.2887 14.3441 9.51203 14.3441 7.40144Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69095 14.1743C9.56213 14.1743 11.1309 13.5537 12.2775 12.4953L10.0378 10.7564C9.41722 11.1722 8.62339 11.418 7.69095 11.418C5.88593 11.418 4.35812 10.1989 3.81315 8.56079H1.4978V10.3564C2.63815 12.6213 4.98184 14.1743 7.69095 14.1743Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81322 8.56092C3.67461 8.1451 3.59586 7.70093 3.59586 7.24416C3.59586 6.78739 3.67461 6.34323 3.81322 5.92741V4.13184H1.49787C1.0285 5.06742 0.760742 6.12587 0.760742 7.24416C0.760742 8.36246 1.0285 9.4209 1.49787 10.3565L3.81322 8.56092Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69096 3.07033C8.70845 3.07033 9.62199 3.41999 10.3402 4.10672L12.3279 2.11899C11.1277 1.00069 9.55898 0.313965 7.69096 0.313965C4.98185 0.313965 2.63815 1.86698 1.4978 4.13192L3.81315 5.92749C4.35812 4.28943 5.88593 3.07033 7.69096 3.07033Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0ffd5ea3a64533937f9936d15ab6d34d.svg";
export { ForwardRef as ReactComponent };